module.exports = __webpack_public_path__ + "img/selectActive.b2ebcd2f.svg";